define('areas/clientteam/parts/getclientteammembers',["require", "exports", "models/account", "services/jsonconverter", "services/settings"], function (require, exports, Account, JsonConverter, Configuration) {
    "use strict";
    var GetClientTeamMembers = (function () {
        function GetClientTeamMembers() {
        }
        GetClientTeamMembers.prototype.get = function () {
            var clientGuid = Account.Session.principal.organizationId;
            var url = "api/PracticePortal/clients/" + clientGuid + "/client-team-members";
            var target = Configuration.Settings.getPracticePortalApi(url);
            var options = this.getAjaxOptions('GET', null, true);
            var response = jQuery.ajax(target, options);
            response.then(function (result) {
                new JsonConverter().convertPropertyNamesToCamelCase(result);
            });
            return response;
        };
        GetClientTeamMembers.prototype.getAjaxOptions = function (type, data, async) {
            var contentType = 'application/json';
            if (data != null && typeof data == "string") {
                contentType = 'text/plain';
            }
            var options = {
                async: async,
                context: this,
                type: type,
                contentType: contentType,
                beforeSend: function (req) {
                    //req.setRequestHeader("Origin", configuration.Settings.getScope());
                    if (Account.Session.isAuthenticated) {
                        req.setRequestHeader("Authorization", Account.Session.getAuthorizationHeader());
                    }
                }
            };
            if (data != null) {
                if (typeof data == "string") {
                    options.data = data;
                }
                else {
                    options.data = JSON.stringify(data);
                }
            }
            return options;
        };
        return GetClientTeamMembers;
    }());
    return GetClientTeamMembers;
});

